import map from 'lodash/map'
import React, { memo } from 'react'

import { TextPersonalizationTypes } from '@Domains/Cart/Components/Prompt/TextPersonalization/types'
import { useTranslation } from '@Globals/Translations'

import styles from './styles.module.scss'

const disclaimer: Record<TextPersonalizationTypes, string[]> = {
  deboss: [
    'products:NO_DELAY_ON_DEBOSSED_PRODUCTS',
    'products:SAME_FONT_AND_TEXT_SIZE_ADJUSTMENT_INFO',
    'products:DEBOSSED_PRODUCTS_ARE_NOT_RETURNABLE',
  ],
  engrave: [
    'products:NO_DELAY_ON_ENGRAVED_PRODUCTS',
    'products:SAME_FONT_AND_TEXT_SIZE_ADJUSTMENT_INFO',
    'products:ENGRAVED_PRODUCTS_ARE_NOT_RETURNABLE',
  ],
}

export const Disclaimer = memo(({ type }: { type: string }) => {
  const { t } = useTranslation()

  if (!disclaimer[type] || disclaimer[type].length === 0) {
    return null
  }

  return (
    <ul className={styles.disclaimer}>
      {map(disclaimer[type], item => <li key={`disclaimer_${item}`}>{t(item)}</li>)}
    </ul>
  )
})
